<script lang="ts">
    import { onMount } from "svelte";
    import Loading from "../components/Loading.svelte";

    interface Props {
        status: string;
    }

    const { status }: Props = $props();

    onMount(() => {
        gtag("event", "page_view", { page_title: "LoadingScreen" });
    });
</script>

<div class="flex flex-1 flex-col items-center justify-center gap-[10px]">
    <Loading />
    <p class="font-semibold">Preparing</p>
    <p class="text-sm opacity-50">{status}</p>
</div>
